import { render, staticRenderFns } from "./Shops.vue?vue&type=template&id=45ee168f&"
import script from "./Shops.vue?vue&type=script&lang=js&"
export * from "./Shops.vue?vue&type=script&lang=js&"
import style0 from "./Shops.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports